import { customArcherColors, Icon, LayoutGrid, Link, makeStyles, theme } from '@archer-technologies/ui-components';
import { DataTypeProvider, DataTypeProviderProps } from '@devexpress/dx-react-grid';
import * as React from 'react';

export type StatusStylingProps = {
  iconColor?: string;
};

const useStyles = makeStyles({
  statusLink: {
    fontSize: '0.875rem',
    fontFamily: 'Lato,Roboto,"Helvetica Neue",Arial,sans-serif'
  },
  statusIconRoot: {
    color: (props: StatusStylingProps) => (props.iconColor ? props.iconColor : theme.palette.primary.main),
    display: 'block',
    margin: '0 auto'
  },
  statusIconOnly: {
    textAlign: 'center'
  },
  statusText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
});

const StatusFormatter = ({ value }: DataTypeProvider.ValueFormatterProps) => {
  const { statusIcon, statusLabel, onClick, iconOnly, isNavigation } = value;
  const statusColor = customArcherColors.getCustomStatusIconColors(statusIcon);
  const statusStylingProps = { iconColor: statusColor };
  const { statusIconRoot, statusIconOnly, statusLink, statusText } = useStyles(statusStylingProps);
  const linkProps = {
    className: statusLink,
    component: isNavigation ? 'a' : 'button'
  };
  const iconProps = iconOnly
    ? {
        titleAccess: statusLabel ? statusLabel : statusIcon
      }
    : {};
  const iconGridSize = !iconOnly ? 2 : 12;

  return value ? (
    <LayoutGrid container>
      {statusLabel && !iconOnly && (
        <LayoutGrid item xs className={statusText}>
          {onClick ? (
            <Link onClick={onClick} {...linkProps}>
              {statusLabel}
            </Link>
          ) : (
            statusLabel
          )}
        </LayoutGrid>
      )}
      {statusIcon && (
        <LayoutGrid item xs={iconGridSize}>
          <Icon icon={statusIcon} fontSize="medium" className={`${statusIconRoot} ${statusIconOnly}`} {...iconProps} />
        </LayoutGrid>
      )}
      {!statusIcon && !statusLabel && (
        <LayoutGrid item xs={iconGridSize}>
          --
        </LayoutGrid>
      )}
    </LayoutGrid>
  ) : null;
};

const StatusTypeProvider = (props: DataTypeProviderProps) => <DataTypeProvider formatterComponent={StatusFormatter} {...props} />;

export { StatusTypeProvider, StatusFormatter };
